import { clearStoreByModuleWise } from "app/_pages/UserManagement/UserRegistration/helper";
import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";

export const CommmonService = {
  userCheck,
  uploadDocument,
  deleteDocument,
  approveReject,
  reorderTableColumns,
  debounce,
  logBigger,
  calculateFraction,
  validateEmail,
  dateConflicts,
  getAge,
  updateQueryParam,
  getQueryParam,
  aadharCheck,
  eployeeIdCheck,
  getInformationTableData,
  getAllSubModule,
  getAllEvents,
  getAllAppCodes,
  updateAppCodeData,
  getDefaultSmtp,
  getAllWorkflowRole,
  updateWorkflowRole,
  fetchPersonalInfo,
  fetchPersonalInfoDetails,
  deleteRecord,
};
async function userCheck(data) {
  try {
    // console.log(data);
    const response = await RestMethod.GET("/common/checkuser/" + data);
    // console.log(response.data.data[0].role.roleLable);
    if (
      response.data.data[0].role.roleLable == "1" ||
      response.data.data[0].role.roleLable == "6"
    ) {
      return "0";
    } else {
      return "1";
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function uploadDocument(data) {
  try {
    const response = await RestMethod.POST("/common/document", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function deleteDocument(id) {
  try {
    const response = await RestMethod.DELETE("/common/document/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function approveReject(data) {
  try {
    const response = await RestMethod.POST("/common/approve-reject", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function reorderTableColumns(data) {
  try {
    const response = await RestMethod.POST("/common/reorder-table-columns", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

function debounce(func, delay = 500) {
  let callable = true;

  return function () {
    const context = this;
    const args = arguments;
    if (callable) {
      callable = false;
      func.apply(context, args);
      setTimeout(() => (callable = true), delay);
    }
  };
}

function logBigger(message = "", extraToLog, color = "red", fontSize = 25) {
  console.log(`%c${message}`, `font-size: ${fontSize}px; color: ${color};`, extraToLog);
}

// ONLY POSITIVE NUMBERS - NEGETIVE NOT ALLOWED!!!
function calculateFraction(string) {
  if (!string) return null;
  if (typeof string === "number") return string;

  let value = 0;

  const parts = string.split(" ");
  if (parts.length > 2) return null;

  const [number, fractionPart] = parts;

  if (isNaN(number) || number < 0) return null;
  value = +number;

  if (fractionPart) {
    const [one, two] = fractionPart.split("/");

    if (!one || !two || isNaN(one) || isNaN(two)) return null;

    value += +one / +two;
  }

  return +value.toFixed(2);
}

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function dateConflicts(oneFromDate, oneToDate, twoFromDate, twoToDate, rangeInDays = 0) {
  const range = (rangeInDays * 24 * 60 * 60 * 1000) / 2;

  const oneFromTime = new Date(oneFromDate).getTime() - range;
  const oneToTime = new Date(oneToDate).getTime() + range;
  const twoFromTime = new Date(twoFromDate).getTime() - range;
  const twoToTime = new Date(twoToDate).getTime() + range;

  return (
    (twoFromTime >= oneFromTime && twoFromTime <= oneToTime) ||
    (twoToTime >= oneFromTime && twoToTime <= oneToTime)
  );
}

function getAge(dob) {
  var ageDifMs = Date.now() - new Date(dob).getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

function updateQueryParam(key, value) {
  if (window.history.replaceState) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, encodeURIComponent(value));
    const newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?" +
      searchParams.toString();
    window.history.replaceState({ path: newurl }, "", newurl);
  }
}

function getQueryParam(key) {
  const query = new URLSearchParams(window.location.search);

  return decodeURIComponent(query.get(key));
}

async function aadharCheck(data) {
  try {
    const response = await RestMethod.POST("/common/aadhar-check", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function eployeeIdCheck(data) {
  try {
    const response = await RestMethod.POST("/common/employee-id-check", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function getInformationTableData() {
  try {
    const response = await RestMethod.GET("/common/admin-configuration");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function getAllSubModule() {
  try {
    console.log("This is get All subModule");
    const response = await RestMethod.GET("/common/all-submodule");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function getAllEvents() {
  try {
    const response = await RestMethod.GET("/common/get-all-events");

    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getAllAppCodes() {
  try {
    const response = await RestMethod.GET("/common/admin-configuration/all-app-code");

    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateAppCodeData(data) {
  try {
    const response = await RestMethod.PUT(
      "/common/admin-configuration/update-app-code",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getDefaultSmtp() {
  try {
    const response = await RestMethod.GET("/common/admin-configuration/default-smtp");

    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getAllWorkflowRole() {
  try {
    const response = await RestMethod.GET(
      "/common/admin-configuration/workflow-role-list"
    );

    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateWorkflowRole(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/common/admin-configuration/update-workflow-role/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function fetchPersonalInfo(filter) {
  try {
    const response = await RestMethod.GET("/common/search-personal-info" + filter);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function fetchPersonalInfoDetails(filter) {
  try {
    let url = "/common/get-personal-info-details" + filter;
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function deleteRecord(filterObj) {
  const { moduleType, deleteFlag = false } = filterObj;
  const query = new URLSearchParams(filterObj).toString();
  const filter = query ? `?${query}` : "";

  try {
    let url = "/common/delete-records" + filter;
    const response = await RestMethod.DELETE(url);
    if (response?.data?.status && deleteFlag) clearStoreByModuleWise(moduleType);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
